import transformerCompteClient from '@/services/compteClient/transformerCompteClient';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/CompteClient/';

export async function getAllPieces(MouvementClientFilter) {
  const inputServer = transformerCompteClient(MouvementClientFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllPiecesAsync', inputServer);
  return response;
}

export async function getSolde(tiersId) {
  const inputServer = { id: tiersId };
  const response = await HTTP.post(URL_BASE + 'PGetSoldeAsync', inputServer);
  return response;
}
